import { Typography } from "@mui/material"
import { AddNewUserButtonWrapper } from "./Atom"

type Props = {}

const AddNewUserButton = (props: any) => {

    const { setOpen } = props

    return (
        <AddNewUserButtonWrapper onClick={() => { setOpen(true) }}>
            <Typography fontSize={14}>
                + Add New User
            </Typography>
        </AddNewUserButtonWrapper>
    )
}

export default AddNewUserButton